module.exports = __webpack_public_path__ + "media/images/rodape_contato-d6550b34caab05b5d8c75c5f1025ab08.png";